const stringUtils = {
    hasCapital: function(str){
        return str !== str.toLowerCase()
    },
    hasLowerCase: function(str) {
        return str !== str.toUpperCase()
    },
    hasDigits: function(str){
        return /\d/.test(str)
    },
    hasSpecialChars: function(str){
        return /[`!@#$%^&*()_\-+=[\]{};':"\\|,.<>/?~]/.test(str)
    },
    isEmpty: function(str) {
        return str.trim() === ''
    },
    lengthToMonthName: function(duration) {
        if (duration === 1) return "месяц"
        if (duration >= 2 && duration <= 4) return "месяца"
        if (duration >= 5) return "месяцев"
    }
}
export default stringUtils